import React from "react";
import classes from "./footer.module.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className={classes.container}>
      <div>
        <Link to="/privacy-policy" style={{ color: "white", fontSize: "12px" }}>
          Privacy policy
        </Link>
        <Link to="/terms-and-condition" style={{marginLeft:'.5rem', color: "white", fontSize: "12px" }}>
        Terms & Conditions
        </Link>
      </div>

      <footer style={{ textAlign: "center", fontSize: "12px", color: "white" }}>
        &copy; Copyright Reserved
      </footer>
    </div>
  );
};

export default Footer;
